import { Backdrop, Fade, Modal } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { cloneElement } from 'react';

const PREFIX = 'GeneralModal';

const classes = {
  modal: `${PREFIX}-modal`,
};

const StyledModal = styled(Modal)(({ theme }) => ({
  [`&.${classes.modal}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiBackdrop-root': {
      zIndex: '-1',
    },
  },
}));

const GeneralModal = ({
  modalState,
  forms,
  handleModalState,
  initFormName,
  closeModal,
  ...props
}) => {
  Object.keys(forms).forEach(key => {
    forms[key] = cloneElement(forms[key], { handleModalState });
  });
  return (
    <StyledModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={modalState}
      onClose={closeModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      {...props}
    >
      <Fade in={modalState}>
        <div>{forms[initFormName]}</div>
      </Fade>
    </StyledModal>
  );
};

export default GeneralModal;
